import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import {
    IconButton,
    Menu,
    MenuItem,
    AppBar,
    Toolbar,
} from '@mui/material';
import {
    AccountCircle,
    Logout,
} from '@mui/icons-material';

import UserService from "../../utils/UserService";

function MainAppBar({ drawerWidth }) {
    const [anchEl, setAnchEl] = useState(null);
    const userMenuOpen = Boolean(anchEl);

    const handleOpen = (e) => setAnchEl(e.currentTarget);
    const handleClose = () => setAnchEl(null);
    const handleLogout = () => UserService.logout();

    return (
        <AppBar
            position="fixed"
            sx={{
                marginLeft: `${drawerWidth}px`,
                width: `calc(100% - ${drawerWidth}px)`,
            }}
        >
            <Toolbar>
                <IconButton
                    style={{ marginLeft: "auto" }}
                    onClick={handleOpen}
                    size="large"
                    color="light"
                    sx={{
                        color: 'rgb(255,255,255)'
                    }}
                >
                    <AccountCircle />
                </IconButton>
                <Menu
                    anchorEl={anchEl}
                    open={userMenuOpen}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleLogout}
                        sx={{
                            gap: 2,
                            color: 'grey.700',
                            '&:hover': {
                                backgroundColor: 'grey.100'
                            },
                        }}
                    >
                        <Logout />
                        <Trans i18nKey='abmelden' ns='appBar'>
                            Abmelden
                        </Trans>
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default MainAppBar;
